module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airport-efbc585b9784fedfe2ea80eca4e75f1b.svg";